module.exports = __webpack_public_path__ + "img/menu_line@_green_icon.0a5fa986.svg";